module.exports = __webpack_public_path__ + "img/small_bg202011252.4e8cad31.png";